import { jsToFormData, paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { Appointment, Attachment, PaginatedResponse } from '../../api/models'

import { API, CustomAxiosConfig } from './types'

type AppointmentAction =
  | 'arrived'
  | 'unarrived'
  | 'docked'
  | 'undocked'
  | 'completed'
  | 'uncompleted'

class AttachmentsAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (
    guid: string,
    config: CustomAxiosConfig = {}
  ): Promise<PaginatedResponse<Attachment>> => {
    const response = await this.api.get(`/scheduling/appointments/${guid}/attachments`, config)
    return paginatedTransform(Attachment)(response.data)
  }

  create = async (guid: string, data: any, config: CustomAxiosConfig = {}): Promise<any> => {
    const axiosConfig = {
      ...config,
      headers: { ...config?.headers, 'Content-Type': 'multipart/form-data' },
    }
    return await this.api.post(
      `/scheduling/appointments/${guid}/attachments`,
      jsToFormData(data),
      axiosConfig
    )
  }
}

export class AppointmentAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<Appointment> => {
    const response = await this.api.get(`/scheduling/appointments/${guid}`, config)
    return rawTransform(Appointment)(response.data)
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Appointment>> => {
    const response = await this.api.get('/scheduling/appointments', config)
    return paginatedTransform(Appointment)(response.data)
  }

  create = async (data: any, config: CustomAxiosConfig = {}): Promise<Appointment> => {
    const response = await this.api.post('/scheduling/appointments', data, config)
    return rawTransform(Appointment)(response.data)
  }

  patch = async (guid: string, data: any, config: CustomAxiosConfig = {}): Promise<Appointment> => {
    const response = await this.api.patch(`/scheduling/appointments/${guid}`, data, config)
    return rawTransform(Appointment)(response.data)
  }

  action = async (
    guid: string,
    action: AppointmentAction,
    config: CustomAxiosConfig = {}
  ): Promise<Appointment> => {
    const response = await this.api.post(`/scheduling/appointments/${guid}/${action}`, {}, config)
    return rawTransform(Appointment)(response.data)
  }

  get attachments() {
    const api = new AttachmentsAPI(this.api)
    Object.defineProperty(this, 'attachments', { value: api })
    return api
  }
}
